import { render, staticRenderFns } from "./ClientRegistrationFinish.vue?vue&type=template&id=feed4c02&scoped=true&"
import script from "./ClientRegistrationFinish.vue?vue&type=script&lang=js&"
export * from "./ClientRegistrationFinish.vue?vue&type=script&lang=js&"
import style0 from "./ClientRegistrationFinish.vue?vue&type=style&index=0&id=feed4c02&prod&lang=scss&"
import style1 from "./ClientRegistrationFinish.vue?vue&type=style&index=1&id=feed4c02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feed4c02",
  null
  
)

export default component.exports